import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { ErrorTrackingService } from './error-tracking.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

    constructor(private injector: Injector) { }

    handleError(error: any): void {
        console.error('Global Error:', error);

        try {
            const errorTracking = this.injector.get(ErrorTrackingService);
            errorTracking.logException(error);
        } catch (e) {
            console.error('[ErrorTracking] Could not send exception:', e);
        }
    }
}